//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './MainboardCertificateClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type SubmitMainboardCertificateQueryParameters = {
  oldMbSerialNumber?: string | undefined ;
  failureCategory?: string | undefined ;
  otherCategoryDetails?: string | null | undefined ;
  requestFile?: Types.FileParameter | null | undefined ;
}

export type SubmitMainboardCertificateMutationParameters = {
  requestFile?: Types.FileParameter | null | undefined ;
}

export type GetResultMainboardCertificateQueryParameters = {
  operationId: number ;
}

export type DownloadMainboardCertificateQueryParameters = {
  fileName?: string | undefined ;
}

export function submitUrl(oldMbSerialNumber?: string | undefined, failureCategory?: string | undefined, otherCategoryDetails?: string | null | undefined): string {
  let url_ = getBaseUrl() + "/api/mainboard-certificate?";
if (oldMbSerialNumber === null)
    throw new Error("The parameter 'oldMbSerialNumber' cannot be null.");
else if (oldMbSerialNumber !== undefined)
    url_ += "OldMbSerialNumber=" + encodeURIComponent("" + oldMbSerialNumber) + "&";
if (failureCategory === null)
    throw new Error("The parameter 'failureCategory' cannot be null.");
else if (failureCategory !== undefined)
    url_ += "FailureCategory=" + encodeURIComponent("" + failureCategory) + "&";
if (otherCategoryDetails !== undefined && otherCategoryDetails !== null)
    url_ += "OtherCategoryDetails=" + encodeURIComponent("" + otherCategoryDetails) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function submitMutationKey(oldMbSerialNumber?: string | undefined, failureCategory?: string | undefined, otherCategoryDetails?: string | null | undefined): MutationKey {
  return trimArrayEnd([
      'MainboardCertificateClient',
      'submit',
      oldMbSerialNumber as any,
      failureCategory as any,
      otherCategoryDetails as any,
    ]);
}

/**
 * Performs submit action for data.
 * @param oldMbSerialNumber (optional) 
 * @param failureCategory (optional) The selected failure category from the predefined catalog.
 * @param otherCategoryDetails (optional) Free-text description provided when the "Other" category is selected.
Optional field for additional details.
 * @param requestFile (optional) 
 */
export function useSubmitMutation<TContext>(oldMbSerialNumber?: string | undefined, failureCategory?: string | undefined, otherCategoryDetails?: string | null | undefined, options?: Omit<UseMutationOptions<Types.StartReplacementOperationResponseDto, unknown, SubmitMainboardCertificateMutationParameters, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.StartReplacementOperationResponseDto, unknown, SubmitMainboardCertificateMutationParameters, TContext> {
  const key = submitMutationKey(oldMbSerialNumber, failureCategory, otherCategoryDetails);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (submitMainboardCertificateMutationParameters: SubmitMainboardCertificateMutationParameters) => Client.submit(oldMbSerialNumber, failureCategory, otherCategoryDetails, submitMainboardCertificateMutationParameters.requestFile),
    mutationKey: key,
  });
}
  
type Submit__MutationParameters = SubmitMainboardCertificateQueryParameters & {
  submitMainboardCertificateMutationParameters: SubmitMainboardCertificateMutationParameters;
}

/**
 * Performs submit action for data.
 * @param oldMbSerialNumber (optional) 
 * @param failureCategory (optional) The selected failure category from the predefined catalog.
 * @param otherCategoryDetails (optional) Free-text description provided when the "Other" category is selected.
Optional field for additional details.
 * @param requestFile (optional) 
 */
export function useSubmitMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.StartReplacementOperationResponseDto, unknown, Submit__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: SubmitMainboardCertificateQueryParameters}): UseMutationResult<Types.StartReplacementOperationResponseDto, unknown, Submit__MutationParameters, TContext> {
  const key = submitMutationKey(options?.parameters?.oldMbSerialNumber!, options?.parameters?.failureCategory!, options?.parameters?.otherCategoryDetails!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options, 
    mutationFn: (data: Submit__MutationParameters) => Client.submit(data.oldMbSerialNumber, data.failureCategory, data.otherCategoryDetails, data.requestFile),
    mutationKey: key,
  });
}
  
export function getResultUrl(operationId: number): string {
  let url_ = getBaseUrl() + "/api/mainboard-certificate/result/{operationId}";
if (operationId === undefined || operationId === null)
  throw new Error("The parameter 'operationId' must be defined.");
url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getResultDefaultOptions: Omit<UseQueryOptions<Types.ReplacementResponseDto, unknown, Types.ReplacementResponseDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ReplacementResponseDto, unknown, Types.ReplacementResponseDto>, 'queryFn'>> = {
};
export function getGetResultDefaultOptions() {
  return getResultDefaultOptions;
};
export function setGetResultDefaultOptions(options: typeof getResultDefaultOptions) {
  getResultDefaultOptions = options;
}

export function getResultQueryKey(operationId: number): QueryKey;
export function getResultQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { operationId,  } = params[0] as GetResultMainboardCertificateQueryParameters;

    return trimArrayEnd([
        'MainboardCertificateClient',
        'getResult',
        operationId as any,
      ]);
  } else {
    return trimArrayEnd([
        'MainboardCertificateClient',
        'getResult',
        ...params
      ]);
  }
}
export function __getResult(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getResult(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetResultQuery<TSelectData = Types.ReplacementResponseDto, TError = unknown>(dto: GetResultMainboardCertificateQueryParameters, options?: Omit<UseQueryOptions<Types.ReplacementResponseDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets result of PKI operation.
 */
export function useGetResultQuery<TSelectData = Types.ReplacementResponseDto, TError = unknown>(operationId: number, options?: Omit<UseQueryOptions<Types.ReplacementResponseDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetResultQuery<TSelectData = Types.ReplacementResponseDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ReplacementResponseDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let operationId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ operationId,  } = params[0] as GetResultMainboardCertificateQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [operationId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ReplacementResponseDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getResult(context, axiosConfig) : __getResult,
    queryKey: getResultQueryKey(operationId),
    ...getResultDefaultOptions as unknown as Omit<UseQueryOptions<Types.ReplacementResponseDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets result of PKI operation.
 */
export function setGetResultData(queryClient: QueryClient, updater: (data: Types.ReplacementResponseDto | undefined) => Types.ReplacementResponseDto, operationId: number) {
  queryClient.setQueryData(getResultQueryKey(operationId),
    updater
  );
}

/**
 * Gets result of PKI operation.
 */
export function setGetResultDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ReplacementResponseDto | undefined) => Types.ReplacementResponseDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function downloadUrl(fileName?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/mainboard-certificate/cert?";
if (fileName === null)
    throw new Error("The parameter 'fileName' cannot be null.");
else if (fileName !== undefined)
    url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let downloadDefaultOptions: Omit<UseQueryOptions<void, unknown, void>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<void, unknown, void>, 'queryFn'>> = {
};
export function getDownloadDefaultOptions() {
  return downloadDefaultOptions;
};
export function setDownloadDefaultOptions(options: typeof downloadDefaultOptions) {
  downloadDefaultOptions = options;
}

export function downloadQueryKey(fileName?: string | undefined): QueryKey;
export function downloadQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { fileName,  } = params[0] as DownloadMainboardCertificateQueryParameters;

    return trimArrayEnd([
        'MainboardCertificateClient',
        'download',
        fileName as any,
      ]);
  } else {
    return trimArrayEnd([
        'MainboardCertificateClient',
        'download',
        ...params
      ]);
  }
}
export function __download(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.download(
      context.queryKey[2] as string | undefined,axiosConfig    );
}

export function useDownloadQuery<TSelectData = void, TError = unknown>(dto: DownloadMainboardCertificateQueryParameters, options?: Omit<UseQueryOptions<void, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * An endpoint for downloading certificates.
 * @param fileName (optional) The certificate file name.
 */
export function useDownloadQuery<TSelectData = void, TError = unknown>(fileName?: string | undefined, options?: Omit<UseQueryOptions<void, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useDownloadQuery<TSelectData = void, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<void, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let fileName: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ fileName,  } = params[0] as DownloadMainboardCertificateQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [fileName, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<void, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __download(context, axiosConfig) : __download,
    queryKey: downloadQueryKey(fileName),
    ...downloadDefaultOptions as unknown as Omit<UseQueryOptions<void, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * An endpoint for downloading certificates.
 * @param fileName (optional) The certificate file name.
 */
export function setDownloadData(queryClient: QueryClient, updater: (data: void | undefined) => void, fileName?: string | undefined) {
  queryClient.setQueryData(downloadQueryKey(fileName),
    updater
  );
}

/**
 * An endpoint for downloading certificates.
 * @param fileName (optional) The certificate file name.
 */
export function setDownloadDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: void | undefined) => void) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function getTestDataUrl(): string {
  let url_ = getBaseUrl() + "/api/mainboard-certificate/cert/get-test-data";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getTestDataDefaultOptions: Omit<UseQueryOptions<void, unknown, void>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<void, unknown, void>, 'queryFn'>> = {
};
export function getGetTestDataDefaultOptions() {
  return getTestDataDefaultOptions;
};
export function setGetTestDataDefaultOptions(options: typeof getTestDataDefaultOptions) {
  getTestDataDefaultOptions = options;
}

export function getTestDataQueryKey(): QueryKey;
export function getTestDataQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'MainboardCertificateClient',
      'getTestData',
    ]);
}
export function __getTestData(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getTestData(
axiosConfig    );
}

/**
 * Get Test Data.
 */
export function useGetTestDataQuery<TSelectData = void, TError = unknown>(options?: Omit<UseQueryOptions<void, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetTestDataQuery<TSelectData = void, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<void, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<void, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getTestData(context, axiosConfig) : __getTestData,
    queryKey: getTestDataQueryKey(),
    ...getTestDataDefaultOptions as unknown as Omit<UseQueryOptions<void, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Get Test Data.
 */
export function setGetTestDataData(queryClient: QueryClient, updater: (data: void | undefined) => void, ) {
  queryClient.setQueryData(getTestDataQueryKey(),
    updater
  );
}

/**
 * Get Test Data.
 */
export function setGetTestDataDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: void | undefined) => void) {
  queryClient.setQueryData(queryKey, updater);
}